import React from "react";
// Common Component
import DatePicker from "src/Components/DatePicker";
import Button from "src/Components/Button";
import FullScreenLoading from "src/Components/Loading/FullScreenLoading";
import { WrappedTimeSeriesChart } from "src/Components/Timeseries/WrappedTimeSeriesChart";
// Requests
import { getDailyReferenceGraphe } from "src/Requests/optionDomain";
// Types
import { Graph_Dto } from "src/Interfaces/orderbookGraphInterfaces";

// Hooks
import { useAppSelector } from "src/App/hooks";
// Utilities
import { packetErrorHandler } from "src/Utils/requestUtils";
import { RefrenceType } from "src/Interfaces/deltaHedgeAdjustment";
import { IReferenceTableReport } from "src/Interfaces/deltaHedgeExe";

interface IProps {
  row: IReferenceTableReport;
}

const ChartUI = ({ row }: IProps) => {
  // local store
  const [loading, setLoading] = React.useState(false);
  const [graphData, setGraphData] = React.useState<Graph_Dto[]>([]);
  const [fromDate, setFromDate] = React.useState(
    getDateFromToday(90).toISOString()
  );
  const [toDate, setToDate] = React.useState(new Date().toISOString());
  // store
  const searchParam = useAppSelector(
    (store) => store.deltaHedgeExePhase3Slice.searchParam
  );

  React.useEffect(() => {
    setLoading(true);
    getDailyReferenceGraphe({
      fromDate,
      toDate,
      groupId: searchParam.groupId,
      refrenceType: row.ref === "CS" ? RefrenceType.CS : RefrenceType.PS,
    })
      .then((resp: Graph_Dto[]) => setGraphData(resp))
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  }, [searchParam.groupId]);

  const handleFromDate = (_: string, value: any) => {
    setFromDate(value);
  };

  const handleToDate = (_: string, value: any) => {
    setToDate(value);
  };
  const onSubmit = () => {
    setLoading(true);
    getDailyReferenceGraphe({
      fromDate,
      toDate,
      groupId: searchParam.groupId,
      refrenceType: row.ref === "CS" ? RefrenceType.CS : RefrenceType.PS,
    })
      .then((resp: Graph_Dto[]) => setGraphData(resp))
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  function getDateFromToday(dayCount: number) {
    const targetDate = new Date();
    targetDate.setDate(new Date().getDate() - dayCount);
    return targetDate;
  }

  const setDateFromBtns = (dayCount: number) => {
    const today = new Date();
    const targetDate = getDateFromToday(dayCount);
    setFromDate(targetDate.toISOString());
    setToDate(today.toISOString());
  };

  const getDateSetterBtn = (dayCount: number) => (
    <Button
      text={`${dayCount} روز`}
      onClick={() => setDateFromBtns(dayCount)}
      variant={
        fromDate?.split("T")[0] ===
        getDateFromToday(dayCount).toISOString()?.split("T")[0]
          ? "contained"
          : "outlined"
      }
    />
  );

  return (
    <>
      <div className="h-full w-full min-h-0 flex flex-row items-stretch gap-5 px-4">
        {loading ? <FullScreenLoading /> : <></>}
        <div className="flex shrink-0 flex-col justify-start items-start gap-3">
          <DatePicker
            label="از تاریخ"
            name="fromDate"
            onChange={handleFromDate}
            value={fromDate}
          />
          <DatePicker
            label="تا تاریخ"
            name="toDate"
            onChange={handleToDate}
            value={toDate}
          />
          <div className="flex flex-row justify-start items-center gap-1 w-full">
            {getDateSetterBtn(7)}
            {getDateSetterBtn(30)}
            {getDateSetterBtn(90)}
          </div>
          <Button text="جستجو" onClick={onSubmit} variant="contained" />
        </div>
        <div className="chart-fill-modal">
          <WrappedTimeSeriesChart dataset={graphData} withDate className="h-full w-full" />
        </div>
      </div>
    </>
  );
};

export default ChartUI;
